import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _class;
import { ComponentPageState } from "abreact/core/pagestate/ComponentPageState";
import { PageStateLogger } from "abreact/core/pagestate/PageStateLogger";
import { PageStateTools } from "abreact/core/pagestate/PageStateTools";
import { action, makeObservable } from "mobx";
export let PageInstanceStateStorage = (_class = class PageInstanceStateStorage {
  constructor(storageIdentity) {
    _defineProperty(this, "_componentQualifiedIdToStorageMap", new Map());
    _defineProperty(this, "_storageIdentity", void 0);
    _defineProperty(this, "_pageStateReporter", void 0);
    makeObservable(this);
    this._storageIdentity = storageIdentity;
    this._pageStateReporter = new PageStateLogger();
  }
  get reporter() {
    return this._pageStateReporter;
  }
  getOrCreateComponentPageState(component, useMobx) {
    let storage = this.findStateStorage(component);
    if (!storage) {
      storage = new ComponentPageState(component, undefined, useMobx);
      this._componentQualifiedIdToStorageMap.set(storage.qualifiedId, storage);
    }
    return storage;
  }
  getStorageIdentity() {
    return this._storageIdentity;
  }
  removeStorage(storage) {
    this._componentQualifiedIdToStorageMap.delete(storage.qualifiedId);
  }
  findStateStorageById(qualifiedId) {
    return this._componentQualifiedIdToStorageMap.get(qualifiedId);
  }
  findStateStorage(component) {
    let storage;
    let qualifiedID = PageStateTools.getQualifiedId(component);
    // If we can find it by qualified it, then use that
    if (qualifiedID) {
      storage = this.findStateStorageById(qualifiedID);
    }
    return storage;
  }
  convertStateStorageToJsonObjects() {
    let storageJsonObjects = [];
    for (const store of this._componentQualifiedIdToStorageMap.values()) {
      let storage = store.toJsonObject();
      if (storage) {
        storageJsonObjects.push(storage);
      }
    }
    return storageJsonObjects;
  }
  restoreCapturedState(stateStorageJsonObjects) {
    let newMap = new Map();
    stateStorageJsonObjects.forEach(jsonStorageObject => {
      /*
      This handles the case where the page is being "restored" to a prior point, kind of like an '
      undo and the components are still on the page. Without reconnecting to the existing storage,
      the new mobx observable maps would not have been read from, so they would be "dead."
       */
      let restoredStorage = ComponentPageState.fromJsonObject(jsonStorageObject);
      let existingStorage = this.findStateStorageById(jsonStorageObject.qualifiedId);
      if (existingStorage) {
        existingStorage.updateValues(restoredStorage.observableValues, restoredStorage.nonObservableValues);
        restoredStorage = existingStorage;
      }
      newMap.set(restoredStorage.qualifiedId, restoredStorage);
    });
    this._componentQualifiedIdToStorageMap = newMap;
  }
}, _applyDecoratedDescriptor(_class.prototype, "restoreCapturedState", [action], Object.getOwnPropertyDescriptor(_class.prototype, "restoreCapturedState"), _class.prototype), _class);
//# sourceMappingURL=PageInstanceStateStorage.js.map
